export type StoryboardColor = {
  color: string;
  legend: string;
};
export type Storyboard = {
  color_legend: Array<StoryboardColor>;
  createdDate?: Date;
  facilitatorCode: string;
  facilitators: Array<string>;
  goals: Array<StoryboardGoal>;
  id: string;
  joinCode?: string;
  name: string;
  owner_id: string;
  personas: Array<StoryboardPersona>;
  updatedDate?: Date;
  users: Array<StoryboardUser>;
  teamId?: string;
  teamName?: string;
};

export type StoryboardColumn = {
  default_story_color: string | null;
  id: string;
  name: string;
  personas: Array<StoryboardPersona>;
  sort_order: string;
  stories: Array<StoryboardStory>;
};

export type StoryboardGoal = {
  columns: Array<StoryboardColumn>;
  default_story_color: string | null;
  id: string;
  name: string;
  personas: Array<StoryboardPersona>;
  sort_order: string;
};

export type StoryboardPersona = {
  id: string;
  name: string;
  role?: string;
  description?: string;
};

export type StoryComment = {
  comment: string;
  created_date: string;
  id: string;
  story_id: string;
  updated_date: string;
  user_id: string;
};

export type StoryboardStory = {
  annotations: Array<string>;
  closed: boolean;
  color: string;
  comments: Array<StoryComment>;
  content: string;
  id: string;
  link: string;
  name: string;
  points: string;
  sort_order: string;
};

export type StoryboardUser = {
  abandoned: boolean;
  active: boolean;
  avatar: string;
  gravatarHash: string;
  id: string;
  name: string;
};

export type ColorLegend = {
  color: string;
  legend: string;
};

export type ColorLegendTemplate = {
  id: string;
  name: string;
  description: string;
  colorLegend: Array<ColorLegend>;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  organizationId?: string;
  teamId?: string;
};

export const storyboardTemplateColors = [
  'gray',
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'blue',
  'indigo',
  'purple',
  'pink',
];

export function buildDefaultColorLegendTemplate(): Array<ColorLegend> {
  return storyboardTemplateColors.map(color => ({ color, legend: '' }));
}
